"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LwpCookieStore = void 0;
const tslib_1 = require("tslib");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
class LwpCookieStore {
    constructor() {
        this.cookieService = js_cookie_1.default.withConverter({
            write(value) {
                return value === null || value === void 0 ? void 0 : value.toString();
            },
            read(value) {
                return value;
            }
        });
    }
    getLocale() {
        const lwp = this.cookieService.get(LwpCookieStore.LWP_COOKIE_NAME);
        const parameters = this.parseLwpValue(lwp);
        if (!Object.prototype.hasOwnProperty.call(parameters, LwpCookieStore.LWP_LANGUAGE_CODE_FIELD) ||
            !Object.prototype.hasOwnProperty.call(parameters, LwpCookieStore.LWP_COUNTRY_CODE_FIELD)) {
            return null;
        }
        const languageCode = parameters['l'].trim();
        const countryCode = parameters['c'].trim();
        if (!languageCode || !countryCode) {
            return null;
        }
        else {
            return `${languageCode.toLowerCase()}_${countryCode.toUpperCase()}`;
        }
    }
    setLocale(localeCode) {
        if (!localeCode) {
            return;
        }
        const parts = localeCode.split('_');
        if (parts.length !== 2) {
            return;
        }
        const languageCode = parts[0];
        const countryCode = parts[1];
        if (!languageCode || !countryCode) {
            return;
        }
        const originalLwp = this.cookieService.get(LwpCookieStore.LWP_COOKIE_NAME);
        const parameters = this.parseLwpValue(originalLwp);
        parameters[LwpCookieStore.LWP_LANGUAGE_CODE_FIELD] = languageCode.toLowerCase();
        parameters[LwpCookieStore.LWP_COUNTRY_CODE_FIELD] = countryCode.toLowerCase();
        const updatedLwp = this.buildLwpValue(parameters);
        this.cookieService.set(LwpCookieStore.LWP_COOKIE_NAME, updatedLwp, {
            path: '/',
            domain: '.dell.com',
            secure: true,
            sameSite: 'None'
        });
    }
    parseLwpValue(lwpValue) {
        const parameters = {};
        if (!lwpValue) {
            return parameters;
        }
        const configs = lwpValue.split('&');
        configs.forEach(item => {
            const parts = item.split('=');
            if (parts.length >= 2) {
                parameters[parts[0]] = parts[1];
            }
        });
        return parameters;
    }
    buildLwpValue(parameters) {
        let lwpValue = '';
        // eslint-disable-next-line
        for (const key of Object.keys(parameters)) {
            lwpValue += `&${key}=${parameters[key]}`;
        }
        lwpValue = lwpValue.substr(1);
        return lwpValue;
    }
}
exports.LwpCookieStore = LwpCookieStore;
LwpCookieStore.LWP_COOKIE_NAME = 'lwp';
LwpCookieStore.LWP_LANGUAGE_CODE_FIELD = 'l';
LwpCookieStore.LWP_COUNTRY_CODE_FIELD = 'c';
//# sourceMappingURL=lwp-cookie.store.js.map